import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'common/api/'

export default {
  namespaced: true,
  state: {
    country: [],
    subject_federation: [],
    federation_borough: [],
    super_towns: [],
    towns: [],
    borough: [],
    streets: []
  },
  mutations: {
    setCountry (state, payload) {
      state.country = payload
    },
    setSubjFed (state, payload) {
      state.subject_federation = payload
    },
    setFederationBorough (state, payload) {
      state.federation_borough = payload
    },
    setSuperTowns (state, payload) {
      state.super_towns = payload
    },
    setTowns (state, payload) {
      state.towns = payload
    },
    setBorough (state, payload) {
      state.borough = payload
    },
    setStreets (state, payload) {
      state.streets = payload
    }
  },
  actions: {
    fetchCountry ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchCountry'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'country/'
        session.get(_url)
          .then(response => {
            commit('setCountry', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchSubjFed ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchSubjFed'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if (payload.country_id > '') {
          params['country_id'] = payload.country_id
        }
        let _url = appURL + 'subject-federation/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setSubjFed', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchFederationBorough ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchFederationBorough'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if (payload.federationSubject_id > '') {
          params['federationSubject_id'] = payload.federationSubject_id
        }
        let _url = appURL + 'federation-borough/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setFederationBorough', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchSuperTowns ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchSuperTowns'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if (payload.boroughSubFed_id > '') {
          params['boroughSubFed_id'] = payload.boroughSubFed_id
        }
        let _url = appURL + 'super-towns/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setSuperTowns', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchTowns ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchTowns'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if (payload.boroughSubFed_id > '') {
          params['boroughSubFed_id'] = payload.boroughSubFed_id
        }
        if (payload.parent_id > '') {
          params['parent_id'] = payload.parent_id
        }
        let _url = appURL + 'towns/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setTowns', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchBorough ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchBorough'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if (payload.town_id > '') {
          params['town_id'] = payload.town_id
        }
        let _url = appURL + 'borough/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setBorough', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchStreets ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchStreets'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if (payload.town_id > '') {
          params['town_id'] = payload.town_id
        }
        if (payload.borough_id > '') {
          params['borough_id'] = payload.borough_id
        }
        let _url = appURL + 'streets/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setStreets', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    country (state) {
      return state.country
    },
    subject_federation (state) {
      return state.subject_federation
    },
    federation_borough (state) {
      return state.federation_borough
    },
    super_towns (state) {
      return state.super_towns
    },
    towns (state) {
      return state.towns
    },
    borough (state) {
      return state.borough
    },
    streets (state) {
      return state.streets
    }
  }
}
